import useToastConfirmation from "../../../../components/common/toasts/useToastConfirmation";
import { useToast } from "../../../../components/common/toasts/ToastContext";
import ErrorToast from "../../../../components/common/toasts/ErrorToast";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PremiumBackLink from "../PremiumBackLink";
import { premiumRequest } from "../../../../services/Premium";
import useUnsavedChanges from "../../../../hooks/useUnsavedChanges";
import useAsyncAction from "../../hooks/useAsyncAction";
import { DictionaryType } from "../../constants";
import { Field } from "../Fields";
import MappingEntryFields from "./MappingEntryFields";
import RecordEntryFields from "./RecordEntryFields";

const editors = {
  [DictionaryType.MAPPING]: MappingEntryFields,
  [DictionaryType.RECORD]: RecordEntryFields,
};

/** Wspólny formularz dodawania i edycji: pola, zapis oraz ochrona niezapisanych zmian. */
export default function DictionaryEntryForm({
  token,
  url,
  definition,
  initialEntry,
  entries,
  listPath,
}) {
  const { notify } = useToast();
  const { confirm } = useToastConfirmation(url);
  const editing = Boolean(initialEntry);
  const emptyEntry = {
    key: "",
    value: definition.type === DictionaryType.RECORD ? {} : "",
  };
  const [entry, setEntry] = useState(initialEntry || emptyEntry);
  const navigate = useNavigate();
  const release = useUnsavedChanges(
    JSON.stringify(entry) !== JSON.stringify(initialEntry || emptyEntry),
  );
  const { busy, error, run } = useAsyncAction(url);
  const save = (event) => {
    event.preventDefault();
    const key = entry.key.trim();
    run(async (isActive) => {
      if (!editing && entries.some((item) => item.key === key)) {
        if (
          !(await confirm(`Wpis „${key}” już istnieje. Zastąpić jego dane?`, {
            acceptLabel: "Zastąp dane",
          })) ||
          !isActive()
        )
          return;
      }
      await premiumRequest(token, url, {
        method: "PUT",
        data: {
          kind: definition.kind,
          key,
          value: entry.value,
          ...(editing ? { previousKey: initialEntry.key } : {}),
        },
      });
      if (isActive()) {
        release();
        notify("Zapisano wpis. Zmiana dotyczy nowych zleceń.");
        navigate(listPath, { replace: true });
      }
    });
  };
  const Fields = editors[definition.type];
  if (!Fields)
    return (
      <ErrorToast message="Nieobsługiwany typ słownika. Odśwież aplikację." />
    );
  return (
    <form onSubmit={save}>
      <ErrorToast message={error} />
      <fieldset disabled={busy} className="premium-grid">
        <Field
          label={definition.keyLabel}
          required
          maxLength={definition.keyMaxLength}
          value={entry.key}
          onChange={(event) =>
            setEntry({
              ...entry,
              key: definition.uppercaseKeys
                ? event.target.value.toUpperCase()
                : event.target.value,
            })
          }
        />
        <Fields
          definition={definition}
          value={entry.value}
          disabled={busy}
          onChange={(value) => setEntry({ ...entry, value })}
        />
      </fieldset>
      <div className="premium-form-actions">
        <PremiumBackLink to={listPath} destination="Lista wpisów słownika" />
        <button disabled={busy} className="btn btn-primary">
          {editing ? "Zapisz zmiany" : "Dodaj wpis"}
        </button>
      </div>
    </form>
  );
}
